// Macro factors arrive from the model with their database column names (booked_date_ftp_rate, cpi_mom).
// This is the one place they are given the names a reader should see.
const LABELS: Record<string, string> = {
  booked_date_ftp_rate: "FTP Rate",
  booked_date_10y2y: "10yr to 2yr Rate Spread",
  rate_shock: "Rate Shock",
  rate_shock_3m_change: "Rate Shock (3 Month Change)",
  cpi_mom: "Monthly CPI",
  // Factors seen in the seed data, spelled out so they read well too.
  unemployment_rate: "Unemployment Rate",
  fed_funds_rate: "Fed Funds Rate",
  gdp_growth_rate: "GDP Growth Rate",
  industrial_production_index: "Industrial Production Index",
  optimism_index: "Optimism Index",
};

const WORDS: Record<string, string> = {
  gdp: "GDP",
  cpi: "CPI",
  ftp: "FTP",
  sofr: "SOFR",
  mom: "Monthly",
  yoy: "Yearly",
  "3m": "3 Month",
  "6m": "6 Month",
  "10y2y": "10yr to 2yr Rate Spread",
};

/** The descriptive name for a macro factor. An unlisted one is made readable (fed_funds_rate becomes
 *  Fed Funds Rate) instead of showing the database name; add it to LABELS to say it exactly. */
export function macroFeatureLabel(feature: string): string {
  const exact = LABELS[feature];
  if (exact) return exact;
  return feature
    .split("_")
    .filter(Boolean)
    .map((w) => WORDS[w.toLowerCase()] ?? w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
